import React, { useEffect } from "react";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import { formatDecimalToTimeHHMM, formatTimeHHMMToDecimal } from '../../utils/timeFormatUtil';

export const TableGroup = ({
    columns,
    data,
    openNovoGrupoAtividadeModal,
    openNotifyGrupoModal,
    openGrupoAtividadeCancelModal,
    openNotifyGrupoHistoricoModal,
    canEdit,
    isFromProjetoInterno
}) => {



    const formatValue = (value) => {
        return value.toLocaleString('pt-br', { style: 'decimal', currency: 'BRL', maximumFractionDigits: 2 });
    };

    const formatCurrency = (value) => {

        return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 });
    };

    const timeStringToDecimalHours = (timeString) => {
        if (!timeString) {
            return;
        }

        const [hours, minutes] = timeString.split(':').map(Number);
        const decimalHours = hours + (minutes / 60);
        return decimalHours.toFixed(2)?.replace(".", ",") ?? "";
    }

    return (
        <StyledTablePage>
            <div>
                {
                    data.itens.map((item) => (
                        <table key={item.Key} className="table table-bordered table-width">
                            <thead>
                                <tr className="table-legend-info">
                                    {columns[0].columns.map(column => (
                                        <th key={column.Header} className={` ${column?.class ?? ''}`}>{column.Header}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {item.Value.map(atividade => {
                                    if (atividade.totalValorFaturado > 0) {
                                        return (
                                            <tr key={atividade.idTimesheetItemGrupoAtividade}
                                                className={atividade.status === 'Notificado' ? 'table-data-info-warning' : atividade.status === 'Cancelado' ? 'table-data-info-canceled' : 'table-data-info'}
                                            >
                                                <td>{atividade.datalancamento}</td>
                                                <td>{atividade.peritoNome}</td>
                                                <td >{atividade.atividade}</td>
                                                <td>{atividade.descricao}</td>
                                                <td>{atividade.periodoInicio}</td>
                                                <td>{atividade.periodoFim}</td>
                                                <td>{[3, 4].includes(atividade.idGrupoAtividade) ? '-' : formatValue(atividade.horasExecutadas)}</td>
                                                <td>{formatCurrency(atividade.valorHoraBase)}</td>
                                                <td>{[3, 4].includes(atividade.idGrupoAtividade) ? timeStringToDecimalHours(formatDecimalToTimeHHMM(atividade.horasExecutadas)) : formatValue(atividade.horaCoeficiente)}</td>
                                                <td>{formatCurrency(atividade.totalValorFaturado)}</td>
                                                <td>{atividade.status}</td>
                                                <td className="fixed-width-95">
                                                    {(item.actions.notificado || item.actions.editar && canEdit) && atividade.status != 'Cancelado' ? <i className="fa fa-pencil table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openNovoGrupoAtividadeModal(item)} title="Editar"></i> : ''} &nbsp;
                                                    {item.actions.cancelar && canEdit && atividade.status != 'Cancelado' ? <i className="fa fa-times table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openGrupoAtividadeCancelModal(item)} title="Cancelar"></i> : ''} &nbsp;
                                                    {item.actions.notificar && atividade.status != 'Cancelado' ? <i className="fa fa-commenting table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openNotifyGrupoModal(item)} title="Notificar"></i> : ''} &nbsp;
                                                    {item.actions.notificar && atividade.status != 'Cancelado' ? <i className="fa fa-bell table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openNotifyGrupoHistoricoModal(item)} title="Notificações"></i> : ''} &nbsp;
                                                </td>
                                            </tr>
                                        )
                                    }
                                    else if (isFromProjetoInterno && atividade.horasExecutadas > 0) {
                                        return (
                                            <tr key={atividade.idTimesheetItemGrupoAtividade}
                                                className={atividade.status === 'Notificado' ? 'table-data-info-warning' : atividade.status === 'Cancelado' ? 'table-data-info-canceled' : 'table-data-info'}
                                            >
                                                <td>{atividade.datalancamento}</td>
                                                <td>{atividade.peritoNome}</td>
                                                <td >{atividade.atividade}</td>
                                                <td>{atividade.descricao}</td>
                                                <td>{atividade.periodoInicio}</td>
                                                <td>{atividade.periodoFim}</td>
                                                <td>{[3, 4].includes(atividade.idGrupoAtividade) ? '-' : formatValue(atividade.horasExecutadas)}</td>
                                                <td>{[3, 4].includes(atividade.idGrupoAtividade) ? formatDecimalToTimeHHMM(atividade.horasExecutadas) : formatValue(atividade.horaCoeficiente)}</td>
                                                <td>{atividade.status}</td>
                                                <td className="fixed-width-95">
                                                    {(item.actions.notificado || item.actions.editar && canEdit) && atividade.status != 'Cancelado' ? <i className="fa fa-pencil table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openNovoGrupoAtividadeModal(item)} title="Editar"></i> : ''} &nbsp;
                                                    {item.actions.cancelar && canEdit && atividade.status != 'Cancelado' ? <i className="fa fa-times table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openGrupoAtividadeCancelModal(item)} title="Cancelar"></i> : ''} &nbsp;
                                                    {item.actions.notificar && atividade.status != 'Cancelado' ? <i className="fa fa-commenting table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openNotifyGrupoModal(item)} title="Notificar"></i> : ''} &nbsp;
                                                    {item.actions.notificar && atividade.status != 'Cancelado' ? <i className="fa fa-bell table-color-button size-icon-acoes" aria-hidden="true" onClick={() => openNotifyGrupoHistoricoModal(item)} title="Notificações"></i> : ''} &nbsp;
                                                </td>
                                            </tr>
                                        )
                                    }
                                })}
                            </tbody>
                        </table>
                    ))
                }
            </div>
        </StyledTablePage>
    );
};
